import React from "react";
import PropTypes from "prop-types";

const DefaultCell = ({ column, row }) => {
  const { dataKey } = column;
  const value = row[dataKey];

  return <>{value}</>;
};

DefaultCell.propTypes = {
  column: PropTypes.shape({
    dataKey: PropTypes.string
  }),
  row: PropTypes.shape()
};

DefaultCell.defaultProps = {
  column: {},
  row: {}
};

export default DefaultCell;
